/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Project-wide upcoming/overdue holding fees
 */
export type TProjectHoldingFeeDueItem = {
    status: TProjectHoldingFeeDueItem.status;
    dueDate: string;
    cycleNumber: number;
    commercialTitles: string;
    performerName: string;
    performerContractId: string;
};
export namespace TProjectHoldingFeeDueItem {
    export enum status {
        DUE = 'Due',
        OVERDUE = 'Overdue',
    }
}

